import { render, staticRenderFns } from "./bannerDetail.vue?vue&type=template&id=c146d178&scoped=true&"
import script from "./bannerDetail.vue?vue&type=script&lang=js&"
export * from "./bannerDetail.vue?vue&type=script&lang=js&"
import style0 from "./bannerDetail.vue?vue&type=style&index=0&id=c146d178&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c146d178",
  null
  
)

export default component.exports